import React from "react";
import { ControlLabel, Button, Alert, FormControl } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import DatePicker from "react-bootstrap-date-picker";

export default class AddForm extends React.Component {
    constructor(props) {
        super(props);
        var dateToday = new Date().toISOString();
        
        this.state = {
            idValue: '',
            title: '',
            titleLabel: '',
            typeLabel: '',
            showOnMainPageLabel: '',
            urlLabel: '',
            saveLabel: '',
            cancelLabel: '',
            addNewLabel: '',
            deleteLabel: '',
            confirmDeleteLabel: '',
            errors: [],
            titleValue: '',
            formTypeValue: '',
            formUrlValue: '',
            formUrlNavigationValue: '',
            deleteDisabled: true,
            alertStyle: '',
            file: null
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onAddNew = this.onAddNew.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onTitleChange = this.onTitleChange.bind(this);
        this.onFormTypeChange = this.onFormTypeChange.bind(this);
        this.onFormUrlChange = this.onFormUrlChange.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    setEditValues(form) {
        self = this;
        let root = context.root();
        
        self.setState({
            titleValue: form.title,
            formTypeValue: form.formType,
            formUrlValue: form.formUrl.toString(),
            formUrlNavigateValue: root + '/' + form.formUrlNavigation.toString(),
        });

        document.getElementById('formtype-select').value = form.formType;
    }

    setAddValues(data) {
        let linkTypeValue = '';

        this.setState({
            titleValue: '',
            formTypeValue: 'Forms',
            formUrlValue: ''
        });
    }

    loadViewModel() {
        let self = this;
        let path = this.props.location.pathname.split('/');
        let id = '';
        let deleteButton = true;
        
        if (!isNaN(parseInt(path[path.length - 1]))) {
            if (path[path.length - 1] != '0') {
                id = path[path.length - 1];
                deleteButton = false;
            }
        }

        self.setState({
            idValue: id,
            deleteDisabled: deleteButton
        });

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(`add-form/${id}`)
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    titleLabel: res.data.titleLabel,
                    typeLabel: res.data.typeLabel,
                    showOnMainPageLabel: res.data.showOnMainPageLabel,
                    urlLabel: res.data.urlLabel,
                    saveLabel: res.data.saveLabel,
                    cancelLabel: res.data.cancelLabel,
                    addNewLabel: res.data.addNewLabel,
                    deleteLabel: res.data.deleteLabel,
                    confirmDeleteLabel: res.data.confirmDeleteLabel
                });

                if (res.data.form.id !== undefined) {
                    if (res.data.form.id > 0) {
                        self.setEditValues(res.data.form);
                    }
                    else {
                        self.setAddValues(res.data);
                    }
                }
                else {
                    self.setAddValues(res.data);
                }

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onSave() {
        var messages = this.validate();
        this.setState({
            errors: messages,
            alertStyle: 'danger'
        });

        if (messages.length == 0) {
            this.save();
        }
    }

    save() {
        let self = this;

        var filename = '';
        var content = '';

        if (self.state.file != null) {
            if (self.state.file.length > 0) {
                filename = self.state.file[0].name;
                var reader = new FileReader();
                reader.readAsArrayBuffer(this.state.file[0]);
                reader.onload = function () {
                    if (self.state.file != null) {
                        if (self.state.file.length > 0) {
                            var binary = '';
                            var bytes = new Uint8Array(reader.result);
                            var len = bytes.byteLength;
                            for (var i = 0; i < len; i++) {
                                binary += String.fromCharCode( bytes[ i ] );
                            }
                            content = btoa(binary);
                        }
                    }
                    
                    var formParam = {
                        Id: self.state.idValue,
                        Title: self.state.titleValue,
                        FormType: self.state.formTypeValue,
                        FileName: filename,
                        FileContent: content
                    };

                    self.saveProcess(formParam);
                };
            }
        }
        else {
            var formParam = {
                Id: self.state.idValue,
                Title: self.state.titleValue,
                FormType: self.state.formTypeValue,
                FileName: filename,
                FileContent: content
            };

            self.saveProcess(formParam);
        }
    }

    saveProcess(formParam) {
        self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        self.setState({
            errors: []
        });

        if (self.state.idValue == '') {
            ajax.api().put(`add-form`, formParam)
                .then(function (res) {
                    context.message({ show: false });
                    let root = context.root();

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            idValue: res.data.form.id,
                            errors: msg,
                            deleteDisabled: false,
                            alertStyle: 'success',
                            formUrlValue: res.data.form.formUrl.toString(),
                            formUrlNavigateValue: root + '/' + res.data.form.formUrlNavigation.toString(),
                            file: null
                        });
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
        else {
            ajax.api().post('edit-form', formParam)
                .then(function (res) {
                    context.message({ show: false });
                    let root = context.root();

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });    
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'success',
                            formUrlValue: res.data.form.formUrl.toString(),
                            formUrlNavigateValue: root + '/' + res.data.form.formUrlNavigation.toString(),
                            fill: null
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    validate() {
        let msg = [];

        if (this.state.titleValue.trim() == '') {
            msg.push('Please enter file title.');
        }

        if (this.state.idValue == '' && this.state.file == null) {
            msg.push('Please click browse to upload the new file.');
        }
        else if (this.state.idValue == '' && this.state.file.length == 0) {
            msg.push('Please click browse to upload the new file.');
        }
        else if (this.state.file != null) {
            if (this.state.file.length > 0) {
                let fileName = this.state.file[0].name.split('.');
                let fileExtension =  fileName[fileName.length - 1].toLowerCase();

                if (fileName.length == 1) {
                    msg.push('Attachment has invalid file type.');
                }
                else if (!(fileExtension == 'pdf' || fileExtension == 'doc' || fileExtension == 'xls')) {
                    msg.push(fileExtension + ' is not supported at this time.(.pdf, .doc, .xls)');
                }
                else if (this.state.file[0].size > (10485760)) {
                    msg.push('Max 10 mb is allowed to upload');
                }
            }
        }

        return msg;
    }


    onBack() {
        let self = this;
        window.location = context.root() + '/app/manage-forms';
    }

    onAddNew() {
        let self = this;
        window.location = context.root() + '/app/add-form/0';
    }

    onDelete() {
        self = this;

        self.setState({
            errors: []
        });

        if (confirm(self.state.confirmDeleteLabel) == true) {
            context.message({
                show: true, 
                type: "loading", 
                message:"Loading. Please wait..."
            });

            ajax.api().post(`delete-form/${this.state.idValue}`)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            idValue: '',
                            deleteDisabled: true,
                            alertStyle: 'success',
                            formUrlValue: '',
                            formUrlNavigationValue: ''
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    onTitleChange(event) {
        this.setState({
            titleValue: event.target.value
        });
    }

    onFormTypeChange() {
        this.setState({
            formTypeValue: this.inputFormType.value
        });
    }

    onFormUrlChange(event) {
        this.setState({
            file: event.target.files
        });
    }

    render() {
        var rowPaddingTopStyle = {
            "padding-top": "10px"
        };

        var requiredStyle = {
            "color": "red"
        };

        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.titleLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" 
                                value={this.state.titleValue}
                                onChange={this.onTitleChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.typeLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl
                                id="formtype-select"
                                componentClass="select"
                                placeholder="select"
                                onChange={this.onFormTypeChange}
                                inputRef={el => this.inputFormType = el}>
                                <option value="Forms" selected="true">Forms</option>
                                <option value="Benefit">Benefit</option>
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.urlLabel} <i className="fa fa-caret-right" style={requiredStyle}></i></ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <span className={this.state.formUrlValue.length > 0 ? "" : "ap-hidden"}>
                                <a href={this.state.formUrlNavigateValue} target="_blank">{this.state.formUrlValue}</a>
                            </span>
                            <FormControl type="file"
                                onChange={this.onFormUrlChange}>
                            </FormControl>    
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-md-3 col-lg-3"></div>
                        <div className="col-md-3 col-lg-9">
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onSave} className="btn-info ap-fullsize" >{this.state.saveLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onBack} className="btn-info ap-fullsize" >{this.state.cancelLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onAddNew} className="btn-info ap-fullsize" >{this.state.addNewLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onDelete} className="btn-info ap-fullsize" disabled={this.state.deleteDisabled}>{this.state.deleteLabel}</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={rowPaddingTopStyle}>
                        <div className="col-md-12 col-lg-12">
                            <div className="col-md-12 col-lg-12">
                                <Alert bsStyle={this.state.alertStyle} className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                    <ul>
                                        {this.state.errors.map(m =>
                                            <li key={m}>{m}</li>)}
                                    </ul>
                                </Alert>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}